
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Modal} from 'react-bootstrap'

import PaymentNoteDoc from './PaymentNoteDoc'

class PaymentNoteDocModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  loadData(pnNo,doc){
    this.refs.pnDocW.getWrappedInstance().loadData(pnNo,doc)
  }

  loadNewDocCreditInstallment(workNo,item,index,noOfPayment,doc){
    this.refs.pnDocW.getWrappedInstance().loadNewDocCreditInstallment(workNo,item,index,noOfPayment,doc)
  }

  render(){
    let {show} = this.props
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
        <Modal.Body>
              <PaymentNoteDoc ref='pnDocW' onSaved={this.props.onSaved} onClose={this.props.onHide}/>
        </Modal.Body>        
      </Modal>  
    )
  }
}

PaymentNoteDocModal.defaultProps = {
  show : false
}


export default PaymentNoteDocModal = connect(
  (state) => ({messages: state.message.view.so.PaymentNoteDocModal}),null,null,{withRef:true}
)(PaymentNoteDocModal);








// WEBPACK FOOTER //
// ./src/view/so/PaymentNoteDocModal.js